<template>

    <div class="picker border border-gray-300 rounded overflow-hidden flex"
        style="
            width: auto;
             height: 35px;
             background: linear-gradient(180deg, rgba(196, 196, 196, 0) 0%, #DFDFDF 100%);
        ">

        <flatPickr class="h-full border-none"
            :config="config"
            :modelValue="value"
            style="width: 40px;"
        />

    </div>

</template>

<script>
import { defineComponent } from "vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { Danish } from 'flatpickr/dist/l10n/da.js';

// Docs - https://github.com/ankurk91/vue-flatpickr-component

export default defineComponent({

    components: {
        flatPickr
    },

    props: {
        value: {
            type: String,
            default: '2021-10-01 00:00:00.000000Z'
        },
        language: {
            type: String,
            default: 'en'
        },
        min_date: {
            type: String,
            default: 'today'
        }
    },


    data() {
        return {
            config: {
                defaultDate: this.value,
                wrap: true,
                altFormat: 'd / m / Y',
                altInput: true,
                minDate: this.min_date,
                locale: this.language,
                allowInput: false,
                onChange:(selectedDates, value, instance) => {

                    this.$emit('new_date',moment( selectedDates[0] ).format() );

                }
            },
        }
    },


    watch: {

        min_date: function(current,prev) {

            this.config.minDate = current;

        }
    }
});
</script>

<style scoped>

</style>
